// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4702":"dedfe552","4752":"1a3830b3","5709":"2fd71c2b","6886":"1a3830b3","7139":"33a6aff9"}[chunkId] + ".chunk.css";
};